import InspectionPhoto from './InspectionPhoto'

export default InspectionPhoto
